// middleware/purgeMiddleware.js
import { signOut } from '../features/authentication/authenticationSlice';
import { persistor } from '../store'; // adjust the import according to your file structure

const purgeMiddleware = (store) => (next) => (action) => {
    if (action.type === signOut.type) {
        persistor.purge();
    }
    return next(action);
};

export default purgeMiddleware;
